<template>
  <v-footer
    clipped-left
    app
    padless
    fixed
    dark
  >
    <v-col
      class="text-center"
      cols="12"
    >
      {{ new Date().getFullYear() }} &copy;
      <span class="font-weight-bold pred--text pr-1">{{ siteCopyRightTitle }}</span>
      <span class="font-weight-thin pyellow--text">LOYALTY</span>
    </v-col>
  </v-footer>
</template>

<script>

export default {
  name      : 'AppFooter',
  components: {},
  directives: {},
  mixins    : [],
  props     : [],
  data () {
    return {}
  },
  computed  : {
    siteCopyRightTitle () {
      return this.$t('Common.App.Title')
    }
  },
  watch     : {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods   : {}
}
</script>

<style scoped>

</style>
